// extracted by mini-css-extract-plugin
export default {"headerBar":"DailyHuddles_headerBar__2t60X"};